var EPSON_E8_U42  = {
    name: "E8-U42",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [135,0,5,119,35,48,17,134,2,63,6,113,2,201,1,150,2,95,159,175,2,0,0,169,36,149,41,74,73,37,37,85,42,70,164,146,84,165,41,36,148,149,84,169,8,],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [135,0,5,160,2,31,6,139,2,183,1,150,35,24,17,178,2,68,159,167,2,0,0,58,171,182,214,187,186,209,58,171,182,214,187,186,208,128,],
        },
        {
            function: "KEY_SOURCE",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [135,0,5,122,2,65,6,91,35,68,17,120,2,225,1,120,2,70,159,142,2,0,0,114,73,57,153,146,114,79,39,145,114,73,57,153,146,114,79,39,144,128,],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,174,175,94,162,119,235,85,93,94,189,68],
        },
        {
            function: "KEY_A",
            name: "KEY_A",
            icon: "KEY_A",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,118,173,98,119,235,85,94,237,90,196],
        },
        {
            function: "KEY_R",
            name: "KEY_R",
            icon: "KEY_R",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,174,171,175,162,119,235,85,93,87,95,68],
        },
        {
            function: "KEY_AUX",
            name: "KEY_AUX",
            icon: "KEY_AUX",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,127,106,162,119,235,85,86,254,213,68],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,125,90,162,119,235,85,94,250,181,68],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,183,123,90,162,119,235,85,110,246,181,68],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,191,90,162,119,235,85,87,126,181,68],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,187,122,218,162,119,235,85,118,245,181,68],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,173,190,218,162,119,235,85,91,125,181,68],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,181,189,218,162,119,235,85,107,123,181,68],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,170,223,218,162,119,235,85,85,191,181,68],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,189,122,186,162,119,235,85,122,245,117,68],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,174,190,186,162,119,235,85,93,125,117,68],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,190,245,90,162,119,235,85,125,234,181,68],
        },
        {
            function: "KEY_LIST",
            name: "KEY_LIST",
            icon: "KEY_LIST",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,183,173,162,119,235,85,87,111,91,68],
        },
        {
            function: "KEY_V",
            name: "KEY_V",
            icon: "KEY_V",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,182,189,186,162,119,235,85,109,123,117,68],
        },
        {
            function: "KEY_FAVORITES",
            name: "KEY_FAVORITES",
            icon: "KEY_FAVORITES",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,181,94,250,162,119,235,85,106,189,245,68],
        },
        {
            function: "KEY_G",
            name: "KEY_G",
            icon: "KEY_G",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,109,219,98,119,235,85,86,219,182,196],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [135,0,5,166,2,31,6,137,2,185,1,141,35,16,17,181,2,73,159,175,2,0,0,58,171,182,221,107,93,209,58,171,182,221,107,93,208,128,],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [135,0,5,162,2,33,6,142,2,180,1,174,35,26,17,170,2,77,159,176,2,0,0,58,171,182,213,117,245,209,58,171,182,213,117,245,208,128,],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [135,0,5,164,2,26,6,147,2,182,1,150,35,21,17,180,2,68,159,177,2,0,0,58,171,182,218,235,117,209,58,171,182,218,235,117,208,128,],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [135,0,5,164,2,35,6,142,2,182,1,148,35,19,17,175,2,70,159,175,2,0,0,58,171,182,215,85,215,209,58,171,182,215,85,215,208,128,],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [135,0,5,159,2,22,6,150,2,179,1,149,35,23,17,175,2,59,159,176,2,0,0,58,171,182,222,171,87,209,58,171,182,222,171,87,208,128,],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,191,117,86,162,119,235,85,126,234,173,68],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,182,218,219,98,119,235,85,109,181,182,196],
        },
        {
            function: "KEY_OPTION",
            name: "KEY_OPTION",
            icon: "KEY_OPTION",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,189,86,162,119,235,85,95,122,173,68],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,239,85,162,119,235,85,87,222,171,68],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [135,0,5,156,2,51,6,124,2,198,1,124,35,18,17,156,2,98,159,177,2,0,0,58,171,182,214,235,181,209,58,171,182,214,235,181,208,128,],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [135,0,5,159,2,37,6,134,2,188,1,146,35,21,17,167,2,61,159,160,2,0,0,58,171,182,213,93,250,209,58,171,182,213,93,250,208,128,],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [135,0,5,164,2,41,6,132,2,186,1,142,35,20,17,167,2,70,159,170,2,0,0,58,171,182,221,118,186,209,58,171,182,221,118,186,208,128,],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [135,0,5,178,2,27,6,140,2,185,1,153,35,248,16,172,2,82,159,178,2,0,0,58,171,182,218,187,122,209,58,171,182,218,187,122,208,128,],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [135,0,5,165,2,21,6,145,2,182,1,158,35,21,17,175,2,90,159,172,2,0,0,58,171,182,219,85,183,209,58,171,182,219,85,183,208,128,],
        },
        {
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [135,0,5,160,2,29,6,132,2,184,1,157,35,13,17,166,2,92,159,190,2,0,0,58,171,182,213,170,247,209,58,171,182,213,170,247,208,128,],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [135,0,5,160,2,29,6,132,2,184,1,157,35,13,17,166,2,92,159,190,2,0,0,58,171,182,213,170,247,209,58,171,182,213,170,247,208,128,],
        },
        {
            function: "KEY_MODE",
            name: "KEY_MODE",
            icon: "KEY_MODE",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,190,186,174,162,119,235,85,125,117,93,68],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,173,86,223,98,119,235,85,90,173,190,196],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,91,87,98,119,235,85,94,182,174,196],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,170,189,245,98,119,235,85,85,123,234,196],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,190,181,87,98,119,235,85,125,106,174,196],
        },
        {
            function: "KEY_PLAYPAUSE",
            name: "KEY_PLAYPAUSE",
            icon: "KEY_PLAYPAUSE",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,182,173,111,98,119,235,85,109,90,222,196],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,181,122,245,98,119,235,85,106,245,234,196],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,183,86,215,162,119,235,85,110,173,175,68],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,87,87,162,119,235,85,94,174,175,68],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,171,215,171,162,119,235,85,87,175,87,68],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [136,0,4,39,2,54,2,39,2,148,6,40,35,138,17,36,2,109,156,59,245,170,175,174,171,162,119,235,85,95,93,87,68],
        },
    ]
}
export default EPSON_E8_U42 